export const contactUS = {
    title: 'Contact us',
    address: 'Address',
    email: 'Email',
    mobile_number: 'Phone Number',
    contact_detail: 'Contact us on Monday - Sunday 09.00 - 17.30, except public holidays.'
}
